module.exports = __webpack_public_path__ + "static/media/postgress.41e89cef.png";